export default {
    buttons: {
        reset_password: 'Сбросить пароль',
    },
    fields: {
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
    },
    errors: {
        email_not_exist: 'Такой email не существует',
    },
}
